export const formatNumber = (number) => {
  return number
    .toString()
    .replace('.', ',')
    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
};

export const formatMoneyWithCurrency = (amount, includeDecimals = true) => {
  return (
    formatNumber(includeDecimals ? amount.toFixed(2) : amount.toFixed(0)) + '€'
  );
};

export const formatMoney = (amount, includeDecimals = true) => {
  return formatNumber(includeDecimals ? amount.toFixed(2) : amount.toFixed(0));
};
